/*
 * Subscription builder (sections/sc-subscription-builder.liquid).
 * Ported from the previous theme's inline script. Unchanged behaviour:
 *   - one card per product, click toggles selection, quantity 1..10 per product
 *   - one selling plan id per delivery frequency (radio group)
 *   - add to cart: POST FormData to /cart/add.js with items[i][id], items[i][quantity], items[i][selling_plan]
 *     for every selected product, then go to /cart
 * Changed on purpose: the free shipping rule reads the theme threshold (data-free-shipping) instead of a
 * hardcoded bag count, money is formatted with the shop currency, and failures show an inline message.
 */
(function () {
  'use strict';

  var MIN_QTY = 1;
  var MAX_QTY = 10;
  var IDLE_LABEL = 'Select Coffee to Continue';

  function init(root) {
    if (!root || root.getAttribute('data-sc-sub-ready')) return;
    root.setAttribute('data-sc-sub-ready', 'true');

    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var currency = root.getAttribute('data-currency') || 'USD';
    var freeShippingThreshold = parseFloat(root.getAttribute('data-free-shipping')) || 0;
    var shippingCost = parseFloat(root.getAttribute('data-shipping-cost')) || 0;
    var noticeTemplate = root.getAttribute('data-notice') || '';

    var selectedProducts = {};
    var selectedFrequency = '';
    var selectedPlanId = '';
    var selectedSummary = '';
    var selectedCadence = '';

    var els = {
      freqInputs: root.querySelectorAll('input[name="sc-sub-frequency"]'),
      cards: root.querySelectorAll('.sc-sub__card'),
      steps: root.querySelectorAll('[data-sub-step]'),
      frequencyText: root.querySelector('[data-sub-frequency-text]'),
      empty: root.querySelector('[data-sub-empty]'),
      items: root.querySelector('[data-sub-items]'),
      totals: root.querySelector('[data-sub-totals]'),
      subtotal: root.querySelector('[data-sub-subtotal]'),
      savings: root.querySelector('[data-sub-savings]'),
      savingsLabel: root.querySelector('[data-sub-savings-label]'),
      shipping: root.querySelector('[data-sub-shipping]'),
      total: root.querySelector('[data-sub-total]'),
      submit: root.querySelector('[data-sub-submit]'),
      error: root.querySelector('[data-sub-error]'),
      notice: root.querySelector('[data-sub-notice]')
    };

    var formatter = null;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency
      });
    } catch (e) {
      formatter = null;
    }

    function money(amount) {
      if (formatter) return formatter.format(amount);
      return '$' + amount.toFixed(2);
    }

    // Seal's configured selling plans use a standard discount at every quantity (display only).
    function getDiscountRate() {
      return (parseFloat(root.getAttribute('data-discount-pct')) || 0) / 100;
    }

    function readFrequency() {
      var checked = root.querySelector('input[name="sc-sub-frequency"]:checked');
      if (!checked) return;
      selectedFrequency = checked.value;
      selectedPlanId = checked.getAttribute('data-plan-id') || '';
      selectedSummary = checked.getAttribute('data-summary') || '';
      selectedCadence = checked.getAttribute('data-cadence') || '';
      if (els.frequencyText) els.frequencyText.textContent = selectedSummary;
    }

    function setHidden(el, hidden) {
      if (!el) return;
      if (hidden) el.setAttribute('hidden', '');
      else el.removeAttribute('hidden');
    }

    function clearError() {
      if (els.error) {
        els.error.textContent = '';
        setHidden(els.error, true);
      }
    }

    function showError(message) {
      if (!els.error) return;
      els.error.textContent = message;
      setHidden(els.error, false);
    }

    function updateSteps() {
      if (els.steps.length < 3) return;
      var hasFrequency = !!selectedFrequency;
      var hasProducts = Object.keys(selectedProducts).length > 0;
      els.steps[0].classList.add('is-active');
      els.steps[1].classList.toggle('is-active', hasFrequency);
      els.steps[2].classList.toggle('is-active', hasProducts);
    }

    function buildItemRow(product, discountedItemTotal) {
      var li = document.createElement('li');
      li.className = 'sc-sub__item';

      var name = document.createElement('span');
      name.className = 'sc-sub__item-name';
      name.textContent = product.title.split('|')[0].trim();

      var qty = document.createElement('span');
      qty.className = 'sc-sub__item-qty';
      qty.textContent = '×' + product.quantity;

      var price = document.createElement('span');
      price.className = 'sc-sub__item-price';
      price.textContent = money(discountedItemTotal);

      li.appendChild(name);
      li.appendChild(qty);
      li.appendChild(price);
      return li;
    }

    function updateSummary() {
      var productsArray = Object.keys(selectedProducts).map(function (key) {
        return selectedProducts[key];
      });

      if (productsArray.length === 0) {
        setHidden(els.empty, false);
        setHidden(els.items, true);
        setHidden(els.totals, true);
        setHidden(els.notice, true);
        if (els.submit) {
          els.submit.disabled = true;
          els.submit.textContent = IDLE_LABEL;
        }
        return;
      }

      setHidden(els.empty, true);
      setHidden(els.items, false);
      setHidden(els.totals, false);
      if (els.submit) els.submit.disabled = false;

      var totalBags = productsArray.reduce(function (sum, p) {
        return sum + p.quantity;
      }, 0);
      var discountPercent = Math.round(getDiscountRate() * 100);

      if (els.submit) {
        els.submit.textContent =
          'Subscribe - ' + totalBags + ' bag' + (totalBags !== 1 ? 's' : '') + ' ' + selectedCadence;
      }

      var originalTotal = 0;
      var discountedTotal = 0;

      while (els.items.firstChild) els.items.removeChild(els.items.firstChild);

      productsArray.forEach(function (product) {
        originalTotal += product.originalPrice * product.quantity;
        // Selling-plan allocation price captured in Liquid.
        var discountedItemTotal = product.price * product.quantity;
        discountedTotal += discountedItemTotal;
        els.items.appendChild(buildItemRow(product, discountedItemTotal));
      });

      // Free shipping: threshold comes from the theme (market metafield or settings.free_shipping_threshold).
      var qualifies = freeShippingThreshold <= 0 || discountedTotal >= freeShippingThreshold;
      var shippingAmount = qualifies ? 0 : shippingCost;

      if (els.shipping) {
        els.shipping.textContent = shippingAmount === 0 ? 'FREE' : money(shippingAmount);
        els.shipping.classList.toggle('is-free', shippingAmount === 0);
      }

      if (els.notice) {
        if (!qualifies && noticeTemplate) {
          els.notice.textContent = noticeTemplate.replace('{amount}', money(freeShippingThreshold - discountedTotal));
          setHidden(els.notice, false);
        } else {
          setHidden(els.notice, true);
        }
      }

      if (els.savingsLabel) els.savingsLabel.textContent = 'Subscription savings (' + discountPercent + '%)';

      var savingsAmount = originalTotal - discountedTotal;
      var finalTotal = discountedTotal + shippingAmount;

      if (els.subtotal) els.subtotal.textContent = money(originalTotal);
      if (els.savings) els.savings.textContent = '-' + money(savingsAmount);
      if (els.total) els.total.textContent = money(finalTotal);
    }

    function setCardSelected(card, selected, quantity) {
      var pick = card.querySelector('.sc-sub__pick');
      var qtyBox = card.querySelector('.sc-sub__qty');
      var qtyValue = card.querySelector('[data-qty-value]');
      card.classList.toggle('is-selected', selected);
      if (pick) pick.setAttribute('aria-pressed', selected ? 'true' : 'false');
      setHidden(qtyBox, !selected);
      if (qtyValue) qtyValue.textContent = String(selected ? quantity : 0);
    }

    function toggleCard(card) {
      var productId = card.getAttribute('data-product-id');
      if (selectedProducts[productId]) {
        setCardSelected(card, false, 0);
        delete selectedProducts[productId];
      } else {
        setCardSelected(card, true, 1);
        selectedProducts[productId] = {
          id: productId,
          variantId: card.getAttribute('data-variant-id'),
          title: card.getAttribute('data-product-title') || '',
          price: parseFloat(card.getAttribute('data-price')),
          originalPrice: parseFloat(card.getAttribute('data-original-price')),
          quantity: 1
        };
      }
      clearError();
      updateSummary();
      updateSteps();
    }

    function changeQuantity(card, change) {
      var productId = card.getAttribute('data-product-id');
      var product = selectedProducts[productId];
      if (!product) return;
      product.quantity = Math.max(MIN_QTY, Math.min(MAX_QTY, product.quantity + change));
      var qtyValue = card.querySelector('[data-qty-value]');
      if (qtyValue) qtyValue.textContent = String(product.quantity);
      updateSummary();
    }

    function addSubscriptionToCart() {
      var productsArray = Object.keys(selectedProducts).map(function (key) {
        return selectedProducts[key];
      });
      if (productsArray.length === 0) return;

      var formData = new FormData();
      productsArray.forEach(function (product, index) {
        // Seal Subscriptions requires this specific format.
        formData.append('items[' + index + '][id]', product.variantId);
        formData.append('items[' + index + '][quantity]', product.quantity);
        formData.append('items[' + index + '][selling_plan]', selectedPlanId);
      });

      clearError();
      if (els.submit) {
        els.submit.disabled = true;
        els.submit.setAttribute('aria-busy', 'true');
      }

      fetch(cartAddUrl, { method: 'POST', body: formData })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw new Error((data && (data.description || data.message)) || 'Request failed');
            }
            return data;
          });
        })
        .then(function () {
          window.location.href = cartUrl;
        })
        .catch(function (error) {
          console.error('Error adding to cart:', error);
          showError('There was an error adding your subscription to the cart. Please try again.');
          if (els.submit) {
            els.submit.disabled = false;
            els.submit.removeAttribute('aria-busy');
          }
        });
    }

    Array.prototype.forEach.call(els.freqInputs, function (input) {
      input.addEventListener('change', function () {
        readFrequency();
        updateSummary();
        updateSteps();
      });
    });

    Array.prototype.forEach.call(els.cards, function (card) {
      card.addEventListener('click', function (event) {
        var stepper = event.target.closest('.sc-sub__qty');
        if (stepper) {
          var button = event.target.closest('[data-qty-change]');
          if (button) changeQuantity(card, parseInt(button.getAttribute('data-qty-change'), 10));
          return;
        }
        toggleCard(card);
      });
    });

    if (els.submit) els.submit.addEventListener('click', addSubscriptionToCart);

    readFrequency();
    updateSummary();
    updateSteps();
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sc-sub]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
